// extracted by mini-css-extract-plugin
module.exports = {"hr":"_2snIo7wdwpgI-ZHvIDgoJn","style13":"_2tLBVcz7Lj3atcSfii9mZW"};